<template>
    <div>

        <b-alert variant="danger" :show="true" class="py-3 mb-1">
            <h5>
                {{ __('configuration.Restart Account') }}
            </h5>
            <p class="pb-0">
                {{ __('configuration.Restart Alert') }}
            </p>
            <div>
                <b-button variant="danger" v-b-modal.resetModal>
                    {{ __('configuration.Restart Account') }}
                </b-button>
            </div>
        </b-alert>

        <b-modal
            id="resetModal"
            :title="__('configuration.Restart Account')"
            hide-footer>

            <b-alert variant="danger" :show="true">
                {{ __('configuration.Please, type your password to confirm this operation') }}
            </b-alert>

            <!-- Form -->
            <form @submit.prevent="restart" novalidate="true">

                <!-- Field -->
                <b-form-group :label="__('configuration.Password')">
                    <b-form-input
                        type="password"
                        v-model="form.password"
                        :class="{ 'is-invalid': form.errors.has('password') }"
                    ></b-form-input>
                    <has-error :form="form" field="password"></has-error>
                </b-form-group>

                <!-- Submit -->
                <b-form-group>
                    <b-button type="submit" variant="danger" :disabled="form.busy">
                        {{ __('configuration.Restart Account') }}
                    </b-button>
                </b-form-group>

            </form>

        </b-modal>
    </div>
</template>

<script>
import { Form } from "vform";

export default {
    props: ['endpoint'],
    data() {
        return {
            loading: false,
            form: new Form({
                password: null,
            })
        }
    },
    methods: {
        restart() {
            this.form.delete(this.endpoint)
                .then(result => {
                    this.$bvModal.hide('resetModal')
                    window.location.reload();
                })
        }
    }
}
</script>

<style scoped>

</style>
